import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddDeliveryGroupModalComponent } from '../../../add-delivery-group-modal/add-delivery-group-modal.component';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { ManagementApiService, UserUtilityService } from 'src/app/services';
import { MatSelectChange } from '@angular/material/select';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { ApprovalDeliveryGroup, ApprovalDeliveryGroupModel, ApprovalRule } from 'src/app/Modules/settings/models/common/setting-area.model';
import { Subject, takeUntil } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { TranslocoService } from '@jsverse/transloco';
import { SelectButtonChangeEvent } from 'primeng/selectbutton';

@Component({
    selector: 'app-rules-content',
    templateUrl: './rules-content.component.html',
    styleUrls: ['./rules-content.component.scss'],
    standalone: false,
})
export class RulesContentComponent {
    @Input() selectedRule: ApprovalRule;
    @Output() ruleConfigureForm = new EventEmitter<any>();
    @Output() enableDisableEmitter = new EventEmitter<any>();
    // @Output() refreshData = new EventEmitter<any>();
    @Input() ruleConfigureFormGroup: UntypedFormGroup;
    @Input() ruleValues: any;
    approvalDeliveryGroups: ApprovalDeliveryGroup[];
    DeliveryGroupList: ApprovalDeliveryGroupModel[];
    dbLookUpItemsNew: any[] = [];
    triggers: any;
    items: any;
    actions: any;
    deliveryGroups: any;
    actionId: number;
    triggerId: number;
    itemId: number;

    stateOptions: any = [
        { label: this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.ENABLED'), value: true },
        { label: this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.DISABLED'), value: false },
    ];
    iscreateRule: boolean;
    iseditRule: boolean;
    isDeleteRolevisible: boolean;
    constructor(
        private modelService: NgbModal,
        private mgmtApi: ManagementApiService,
        private user_utility: UserUtilityService,
        private globalEmiiterService: GlobalEmittersService,
        private NgxUiLoaderService: NgxUiLoaderService,
        private cd: ChangeDetectorRef,
        private transLocoService: TranslocoService
    ) {}

    ngOnInit(): void {
        this.LoadLookUp(1);
        this.LoadLookUp(4);
        this.LoadLookUp(3);
        this.checkPermissions();

        // this.ruleConfigureForm.emit(this.ruleConfigureFormGroup);
        // this.ruleConfigureFormGroup.valueChanges.subscribe(() => {
        //     this.ruleConfigureForm.emit(this.ruleConfigureFormGroup);
        // });
    }
    async checkPermissions() {
        this.iseditRule = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-rules', userActions.Edit);
        this.isDeleteRolevisible = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-rules', userActions.Delete);
        this.iscreateRule = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-rules', userActions.Create);
        const shouldDisable = this.selectedRule?.approvalRuleId && this.selectedRule?.approvalRuleId != '0' && !this.iseditRule;

        if (shouldDisable) {
            this.ruleConfigureFormGroup.disable({ emitEvent: false });
        } else {
            this.ruleConfigureFormGroup.enable({ emitEvent: false });
        }
    }
    async ManageDeliveryGroup() {
        this.NgxUiLoaderService.start();
        let data = await this.mgmtApi.getDeliveryGroups().toPromise();
        if (data.success && data.response) {
            this.DeliveryGroupList = data.response;
            if (this.DeliveryGroupList?.length > 0) {
                this.mapDbselect(this.DeliveryGroupList, true);
            } else {
                this.NgxUiLoaderService.stop();
                this.loadDeliveryGroupModal(null);
            }
        } else {
            this.NgxUiLoaderService.stop();
        }
    }

    mapDbselect(dblookup: ApprovalDeliveryGroupModel[], flag: boolean) {
        const result = [];
        dblookup.forEach((array) => {
            const parentItem = {
                id:
                    array.deliveryGroupId == null || array.deliveryGroupId == '' || array.deliveryGroupId == undefined
                        ? array.userDeliveryGroupId
                        : array.deliveryGroupId,
                name: array.name,
                displayName: array.name,
                parentId: 0,
            };
            result.push(parentItem);

            if (array?.userDeliveryGroups && array?.userDeliveryGroups?.length > 0) {
                let childItems = array.userDeliveryGroups.map((child) => ({
                    id: child.userDeliveryGroupId,
                    name: child.user.profileContact.email,
                    displayName: child.user.profileContact.email,
                    parentId: array.deliveryGroupId,
                }));
                result.push(...childItems);
            }
        });
        this.dbLookUpItemsNew = result;
        if (flag) this.loadDeliveryGroupModal(this.dbLookUpItemsNew);
        else {
            this.globalEmiiterService.deliveryGroupUpdateEvent.next(this.dbLookUpItemsNew);
        }
        this.NgxUiLoaderService.stop();
    }

    async loadData() {
        this.NgxUiLoaderService.start();
        let data = await this.mgmtApi.getDeliveryGroups().toPromise();
        if (data.success && data.response) {
            this.DeliveryGroupList = data.response;
            if (this.DeliveryGroupList?.length > 0) {
                this.mapDbselect(this.DeliveryGroupList, false);
            } else {
                this.NgxUiLoaderService.stop();
            }
        }
    }

    loadDeliveryGroupModal(data: any[]) {
        // this.ruleConfigureFormGroup.get('groups').setValue([]);
        let dialogRef = this.modelService.open(AddDeliveryGroupModalComponent, {
            size: 'lg',
        });
        dialogRef.componentInstance.DeliveryGroupList = data?.length > 0 ? data : [];
        dialogRef.componentInstance.deliveryGroupUpdated.subscribe((updatedList: boolean) => {
            if (updatedList) {
                this.loadData();
                this.LoadLookUp(3);
            }
        });
    }

    async LoadLookUp(lookup: any, trigger?: any) {
        let data = await this.mgmtApi.getApprovalLookUps(lookup, trigger).toPromise();
        if (data.success) {
            if (lookup == 1) {
                this.triggers = data.response;
                if (this.selectedRule?.trigger) {
                    //this.ruleConfigureFormGroup.get('trigger').setValue(this.selectedRule.trigger);
                    this.LoadLookUp(2, this.selectedRule.trigger);
                    this.cd.detectChanges();
                }
            }
            if (lookup == 2) {
                this.items = data.response;
                if (this.selectedRule.item) {
                    //this.ruleConfigureFormGroup.get('item').setValue(this.selectedRule.item);
                    this.cd.detectChanges();
                }
            }
            if (lookup == 3) {
                this.deliveryGroups = data.response;
                if (this.ruleConfigureFormGroup.get('groups').value) {
                    this.cd.detectChanges();
                }
            }
            if (lookup == 4) {
                this.actions = data.response;
                //if (this.selectedRule.action) this.ruleConfigureFormGroup.get('action').setValue(this.selectedRule.action);
                this.cd.detectChanges();
            }
        } else {
            this.user_utility.errorModelPopup(data.message);
        }
    }

    selectLookUp(selectedValue: MatSelectChange): void {
        this.triggerId = selectedValue.value;
        this.LoadLookUp(2, this.triggerId);
        this.ruleConfigureForm.emit(this.ruleConfigureFormGroup);
    }
    itemSelect(selectedValue: MatSelectChange): void {
        this.ruleConfigureForm.emit(this.ruleConfigureFormGroup);
    }
    deliveryGroupselect(selectedValue: MatSelectChange): void {
        this.ruleConfigureForm.emit(this.ruleConfigureFormGroup);
    }
    actionSelect(selectedValue: MatSelectChange): void {
        this.ruleConfigureForm.emit(this.ruleConfigureFormGroup);
    }
    // toggleSwitch(event: MouseEvent) {
    //     this.selectedRule.enabled = this.ruleConfigureFormGroup.get('enabled')?.value;
    //     // this.enableDisableEmitter.emit(this.ruleConfigureFormGroup.get('enabled')?.value);
    //     this.ruleConfigureForm.emit(this.ruleConfigureFormGroup);
    // }
    toggleSwitch(event: SelectButtonChangeEvent) {
        this.selectedRule.enabled = event.value;
        this.ruleConfigureForm.emit(this.ruleConfigureFormGroup);
    }
    disable(): boolean {
        return this.selectedRule?.approvalRuleId && this.selectedRule?.approvalRuleId != '0' && !this.iseditRule;
    }
}
